module.exports = __webpack_public_path__ + "c750d568e0fd69230602c4e8a6f1242f.png";